import axios, { headers } from './base';
import { apiUrlBase } from '../../../configuration';
import { LLMRequest } from '../../entities/LLMRequest';
import { LLMResponse } from '../../entities/LLMResponse';
import { UserSaved } from '../storage';

export async function generateLLM(user: UserSaved, request: LLMRequest): Promise<LLMResponse> {
  return axios
    .post(`${apiUrlBase}LLM`, request, {
      headers: headers(user.token),
    })
    .then((response) => response.data);
}
